import React, { createContext, useContext, useState } from 'react';

const EventBusContext = createContext();

export const EventBusProvider = ({ children }) => {
  const [listeners, setListeners] = useState({});

  const subscribe = (event, callback) => {
    setListeners((prevListeners) => ({
      ...prevListeners,
      [event]: [...(prevListeners[event] || []), callback],
    }));
  };

  const unsubscribe = (event, callback) => {
    setListeners((prevListeners) => ({
      ...prevListeners,
      [event]: (prevListeners[event] || []).filter((cb) => cb !== callback),
    }));
  };

  const emit = (event, payload) => {
    setListeners(prevListeners => {
      // In this case, we are not updating the listeners, but the getting latest value of listeners
      (prevListeners[event] || []).forEach((callback) => callback(payload));
      return prevListeners;
    })
  };


  return (
    <EventBusContext.Provider value={{ subscribe, unsubscribe, emit }}>
      {children}
    </EventBusContext.Provider>
  );
};

export const useEventBus = () => {
  const context = useContext(EventBusContext);
  if (!context) {
    throw new Error('useEventBus must be used within an EventBusProvider');
  }
  return context;
};
